import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { URL } from '../../util/ambienteActions';
import { ATIVAR_ITINERARIO_EM_LOTE, INATIVAR_ITINERARIO_EM_LOTE, LIMPAR_RESULTADO_ATIVACAO_ITINERARIO_EM_LOTE } from '../types';

export function ativarItinerarioEmLote(parametros) {
    const url = `${URL}/itinerario/ativar-em-lote`;
        
    return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
        type: ATIVAR_ITINERARIO_EM_LOTE,
        payload: response
        })
    );
}

export function inativarItinerarioEmLote(parametros) {
    const url = `${URL}/itinerario/inativar-em-lote`;

    return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
        type: INATIVAR_ITINERARIO_EM_LOTE,
        payload: response
        })
    );
}

export function limpaResultadoAtivacaoItinerarioEmLote() {
    return {
      type: LIMPAR_RESULTADO_ATIVACAO_ITINERARIO_EM_LOTE
    }
}